import { PlusIcon } from '@heroicons/react/24/outline';

import { Restricted } from 'containers/Restricted';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { EmptyKeysIllustration } from '@atoms/illustrations/EmptyKeysIllustration';

import {
  AUTHENTICATION_EMPTY_CTA_TEST_ID,
  AUTHENTICATION_EMPTY_TEST_ID
} from './constants';

import { EMPTY_STATE_MIN_HEIGHT } from '../constants';

type AuthenticationEmptyStateProps = {
  onCreate: () => void;
};

export const AuthenticationEmptyState = ({
  onCreate
}: AuthenticationEmptyStateProps) => (
  <div
    data-testid={AUTHENTICATION_EMPTY_TEST_ID}
    className={`flex ${EMPTY_STATE_MIN_HEIGHT} flex-1 flex-col items-center justify-center gap-6`}
  >
    <EmptyKeysIllustration
      data-testid="developers_authentication_empty_illustration"
      className="size-[99px]"
    />
    <p className="text-lg font-medium leading-[22px] text-content-strong">
      No API keys exist yet
    </p>
    <Restricted requiredPermission="developers:manage">
      <PrimaryButton
        data-testid={AUTHENTICATION_EMPTY_CTA_TEST_ID}
        icon={<PlusIcon className="size-4" />}
        onClick={onCreate}
      >
        Create API key
      </PrimaryButton>
    </Restricted>
  </div>
);
